const { getRequestId } = require('../requestIdService');

module.exports.logToSentry = (msg, extra = {}, level = 'error') => {
  import('@sentry/nextjs').then((Sentry) => {
    Sentry.withScope((scope) => {
      scope.setLevel(level);
      scope.setExtras({
        ...extra,
        requestId: getRequestId(),
      });
      Sentry.captureMessage(msg);
      Sentry.flush(2000);
    });
  });
};

module.exports.logSentryError = (error, _extra) => {
  const extra =
    typeof _extra === 'string'
      ? {
          message: _extra,
        }
      : _extra;

  import('@sentry/nextjs').then((Sentry) => {
    Sentry.withScope((scope) => {
      scope.setLevel('error');
      scope.setExtras({
        ...extra,
        requestId: getRequestId(),
      });
      Sentry.captureException(error);
      Sentry.flush(2000);
    });
  });
};
